import { Overflow, TabList } from "@fluentui/react-components";

import { memo } from "react";
import { useTabContainerStyles } from "../styles/TabsContainer.styles";
import { OverflowMenu } from "./OverflowMenu";
import { TabItems } from "./TabItems";

type TabsContainerProps = {
  tabs: Array<{ id: string; name: string }>;
  selectedTab: string;
  onTabSelectionChange: (id: string) => void;
  onCloseClicked: (id: string) => void;
};

export const TabsContainer = memo(({ tabs, selectedTab, onTabSelectionChange, onCloseClicked }: TabsContainerProps) => {
  const styles = useTabContainerStyles();
  return (
    <Overflow padding={0} overflowDirection="start">
      <TabList
        size="small"
        className={styles.tabContainer}
        defaultSelectedValue={selectedTab}
        selectedValue={selectedTab}
        onTabSelect={(_ev, data) => onTabSelectionChange(data.value as string)}
      >
        <OverflowMenu tabs={tabs} onTabSelect={onTabSelectionChange} onClose={onCloseClicked} />
        <TabItems tabs={tabs} selectedTab={selectedTab} onClose={onCloseClicked} />
      </TabList>
    </Overflow>
  );
});
